import Component from './MonitoredDocumentChangesBrowser.component.jsx';
import { connect } from 'react-redux';
import { fetchMonitoredDocumentChanges } from '../../state/actions/MonitoredDocumentActions';
import fromState from '../../state/selectors';

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    return {
        fetching: fromState.MonitoredDocumentChanges.isFetching(state),
        fetched: fromState.MonitoredDocumentChanges.isFetched(state),
        failed: fromState.MonitoredDocumentChanges.hasFailed(state),
        monitoredDocumentChanges:
            fromState.MonitoredDocumentChanges.getMonitoredDocumentChanges(state),
        paging: fromState.MonitoredDocumentChanges.getPaging(state),
    };
};

const mapDispatchToProps = (dispatch, { pageSize }) => {
    return {
        fetchMonitoredDocumentChanges: ({ pageNumber = 1, pageSize: defaultPageSize = 20 } = {}) =>
            dispatch(fetchMonitoredDocumentChanges(pageNumber, pageSize || defaultPageSize)),
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { pageSize } = ownProps;
    const {
        paging: { pageSize: defaultPageSize = 20 },
    } = stateProps;
    return {
        ...ownProps,
        ...stateProps,
        paging: {
            ...stateProps.paging,
            pageSize: pageSize || defaultPageSize,
        },
        onInitialLoad: dispatchProps.fetchMonitoredDocumentChanges,
        onPageClick: dispatchProps.fetchMonitoredDocumentChanges,
    };
};

// EXPORT CONTAINER
export default connect(mapStateToProps, mapDispatchToProps, mergeProps, { forwardRef: true })(
    Component
);
